import type { VariantDefinition } from '../factory';

export const cardDefinition = {
  variants: {
    variant: {
      default: 'bg-card border border-border text-card-foreground',
      outlined: 'bg-background border border-border text-foreground',
      elevated: 'bg-card border border-border text-card-foreground shadow-lg',
      ghost: 'bg-transparent border-transparent',
      flat: 'bg-card border-0 text-card-foreground',
      interactive: 'bg-card border border-border text-card-foreground',
    },
  },
  defaultVariants: {
    variant: 'default',
  },
} satisfies VariantDefinition;

export type CardVariant = keyof typeof cardDefinition.variants.variant;
